export default "__VITE_ASSET__DctYcMnU__"